import { AxiosInstance } from 'axios';
import {
  ReportEndpoints,
  CreateReportRequest,
  CreateReportResponse,
  GetReportRequest,
  GetReportResponse,
  GetReportsRequest,
  GetReportsResponse,
  UpdateReportRequest,
  UpdateReportResponse,
  DeleteReportRequest,
  DeleteReportResponse,
} from './ReportServices.types';

import { ExportReportServices } from './services';

export class ReportServices implements ReportEndpoints {
  instance: AxiosInstance;
  exports: ExportReportServices;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.exports = new ExportReportServices(instance);
  }

  search(request: GetReportsRequest) {
    return this.instance.get<GetReportsResponse>('/reports', {
      params: request.queryParams,
    });
  }

  getById(request: GetReportRequest) {
    return this.instance.get<GetReportResponse>(`/reports/${request.reportId}`);
  }

  create(request: CreateReportRequest) {
    return this.instance.post<CreateReportResponse>('/reports', request.body);
  }

  update(request: UpdateReportRequest) {
    return this.instance.patch<UpdateReportResponse>(
      `/reports/${request.routeParams.reportId}`,
      request.body,
    );
  }

  delete(request: DeleteReportRequest) {
    return this.instance.delete<DeleteReportResponse>(`/reports/${request.reportId}`);
  }
}
